"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * eXtend Media Paywall Service API
 * Media Wall API Specification
 *
 * The version of the OpenAPI document: v1
 * Contact: t.ioannidis@extend.gr
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
 * The MediaKeyTakeAwayModel model module.
 * @module model/MediaKeyTakeAwayModel
 * @version 1.1.3-alpha.1
 */
class MediaKeyTakeAwayModel {
  /**
   * Constructs a new <code>MediaKeyTakeAwayModel</code>.
   * @alias module:model/MediaKeyTakeAwayModel
   */
  constructor() {
    MediaKeyTakeAwayModel.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  static initialize(obj) {}

  /**
   * Constructs a <code>MediaKeyTakeAwayModel</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/MediaKeyTakeAwayModel} obj Optional instance to populate.
   * @return {module:model/MediaKeyTakeAwayModel} The populated <code>MediaKeyTakeAwayModel</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new MediaKeyTakeAwayModel();
      if (data.hasOwnProperty('id')) {
        obj['id'] = _ApiClient.default.convertToType(data['id'], 'String');
      }
      if (data.hasOwnProperty('caption')) {
        obj['caption'] = _ApiClient.default.convertToType(data['caption'], 'String');
      }
      if (data.hasOwnProperty('timeout')) {
        obj['timeout'] = _ApiClient.default.convertToType(data['timeout'], 'Number');
      }
    }
    return obj;
  }

  /**
   * Validates the JSON data with respect to <code>MediaKeyTakeAwayModel</code>.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @return {boolean} to indicate whether the JSON data is valid with respect to <code>MediaKeyTakeAwayModel</code>.
   */
  static validateJSON(data) {
    // ensure the json data is a string
    if (data['id'] && !(typeof data['id'] === 'string' || data['id'] instanceof String)) {
      throw new Error("Expected the field `id` to be a primitive type in the JSON string but got " + data['id']);
    }
    // ensure the json data is a string
    if (data['caption'] && !(typeof data['caption'] === 'string' || data['caption'] instanceof String)) {
      throw new Error("Expected the field `caption` to be a primitive type in the JSON string but got " + data['caption']);
    }
    return true;
  }
}

/**
 * @member {String} id
 */
MediaKeyTakeAwayModel.prototype['id'] = undefined;

/**
 * @member {String} caption
 */
MediaKeyTakeAwayModel.prototype['caption'] = undefined;

/**
 * @member {Number} timeout
 */
MediaKeyTakeAwayModel.prototype['timeout'] = undefined;
var _default = exports.default = MediaKeyTakeAwayModel;